import { useState, useEffect } from 'react'
import { AuthChangeRedirector, AnonymousRoute, AuthenticatedRoute } from './auth'
import {
  createBrowserRouter,
  RouterProvider
} from 'react-router-dom'
// import Dashboard from './Dashboard'
import Login from './pages/account/Login'
import RequestLoginCode from './pages/account/RequestLoginCode'
import ConfirmLoginCode from './pages/account/ConfirmLoginCode'
import Logout from './pages/account/Logout'
import Signup from './pages/account/Signup'
import ProviderSignup from './socialaccount/ProviderSignup'
import ProviderCallback from './socialaccount/ProviderCallback'
import MainPage from './pages/MainPage';
import NewMainPage from './pages/NewMainPage';
import MainPageButtonTest from './pages/MainPageButtonTest';
import ChangeEmail from './pages/account/ChangeEmail'
import ManageProviders from './socialaccount/ManageProviders'
import VerifyEmail, { loader as verifyEmailLoader } from './pages/account/VerifyEmail'
import VerifyEmailByCode from './pages/account/VerifyEmailByCode'
import Reauthenticate from './pages/account/Reauthenticate'
import VerificationEmailSent from './pages/account/VerificationEmailSent'
import RequestPasswordReset from './pages/account/RequestPasswordReset'
import ChangePassword from './pages/account/ChangePassword'
import ResetPassword, { loader as resetPasswordLoader } from './pages/account/ResetPassword'
import Sessions from './usersessions/Sessions'
import Root from './Root'
import { useConfig } from './auth/hooks'
import SettingsPage from './pages/SettingsPage'
import Contestants from './pages/Contestants'
import About from './pages/About'
import ChooseLevel from './pages/ChooseLevel'
import ChooseGameMode from './pages/ChooseGameMode'
import ExploreGame from './pages/ExploreGame'
import ComfortableGame from './pages/ComfortableGame'
import OpenGame from './pages/OpenGame'
import NotFoundPage from './pages/NotFoundPage'
import UserProfile from './pages/account/UserProfile'
import SuccessPaymentPage from './pages/account/SuccessPaymentPage'
import SuccessRedeemPage from './pages/account/SuccessRedeemPage'
import PaymentPage from './pages/account/PaymentPage'
import { PremiumRoute } from './auth/routing'
import DemoGame from './pages/DemoGame'
import RulesPage from './pages/RulesPage'
import Health from './pages/Health'
import FAQ from './pages/FAQ'
import ChooseRelationship from './pages/ChooseRelationship'
import DownloadPage from './pages/DownloadPage'


function createRouter (config) {
  return createBrowserRouter([
    {
      path: '/',
      element: <AuthChangeRedirector><Root /></AuthChangeRedirector>,
      children: [
        {
          path: '/',
          element: <NewMainPage />
        },
        {
          path: '/buttontest',
          element: <MainPageButtonTest />
        },
        {
          path: '/settingspage',
          element: <SettingsPage />
        },
        {
          path: '/health',
          element: <Health />
        },
        {
          path: '/rules',
          element: <RulesPage />
        },
        {
          path: '/faq',
          element: <FAQ />
        },
        {
          path: '/download',
          element: <DownloadPage />
        },
        {
          path: '/contestants',
          element: <Contestants />
        },
        {
          path: '/chooserelationship',
          element: <ChooseRelationship />
        },
        {
          path: '/about',
          element: <About />
        },
        {
          path: '/choosegamemode',
          element: <ChooseGameMode />
        },
        {
          path: '/chooselevel',
          element: <ChooseLevel />
        },
        {
          path: '/exploregame',
          element: <AuthenticatedRoute><PremiumRoute><ExploreGame /></PremiumRoute></AuthenticatedRoute>
        },
        {
          path: '/comfortgame',
          element: <AuthenticatedRoute><PremiumRoute><ComfortableGame /></PremiumRoute></AuthenticatedRoute>
        },
        {
          path: '/demogame',
          element: <AuthenticatedRoute><DemoGame /></AuthenticatedRoute>
        },
        {
          path: '/opengame',
          element: <AuthenticatedRoute><PremiumRoute><OpenGame /></PremiumRoute></AuthenticatedRoute>
        },
        // {
        //   path: '/dashboard',
        //   element: <AuthenticatedRoute><Dashboard /></AuthenticatedRoute>
        // },
        {
          path: '/account/login',
          element: <AnonymousRoute><Login /></AnonymousRoute>
        },
        {
          path: '/account/login/code',
          element: <AnonymousRoute><RequestLoginCode /></AnonymousRoute>
        },
        {
          path: '/account/login/code/confirm',
          element: <AnonymousRoute><ConfirmLoginCode /></AnonymousRoute>
        },
        {
          path: '/account/email',
          element: <AuthenticatedRoute><ChangeEmail /></AuthenticatedRoute>
        },
        {
          path: '/account/logout',
          element: <Logout />
        },
        // {
        //   path: '/account/provider/callback',
        //   element: <ProviderCallback />
        // },
        // {
        //   path: '/account/provider/signup',
        //   element: <AnonymousRoute><ProviderSignup /></AnonymousRoute>
        // },
        {
        path: '/account/reauthenticate',
        element: <AuthenticatedRoute><Reauthenticate/></AuthenticatedRoute>
        },
        // {
        //   path: '/account/providers',
        //   element: <AuthenticatedRoute><ManageProviders /></AuthenticatedRoute>
        // },
        {
          path: '/account/signup',
          element: <AnonymousRoute><Signup /></AnonymousRoute>
        },
        {
          path: '/account/verify-email',
          element: config.data.account.email_verification_by_code_enabled ? <VerifyEmailByCode /> : <VerificationEmailSent />
        },
        {
          path: '/account/verify-email/:key',
          element: <VerifyEmail />,
          loader: verifyEmailLoader
        },
        {
          path: '/account/password/reset',
          element: <AnonymousRoute><RequestPasswordReset /></AnonymousRoute>
        },
        {
          path: '/account/password/reset/key/:key',
          element: <AnonymousRoute><ResetPassword /></AnonymousRoute>,
          loader: resetPasswordLoader
        },
        {
          path: '/account/password/change',
          element: <AuthenticatedRoute><ChangePassword /></AuthenticatedRoute>
        },
        // {
        //   path: '/account/sessions',
        //   element: <AuthenticatedRoute><Sessions /></AuthenticatedRoute>
        // },
        {
          path: '/account/profile/',
          element: <AuthenticatedRoute><UserProfile/></AuthenticatedRoute>
        },
        {
          path : "/account/paymentpage",
          element: <AuthenticatedRoute><PaymentPage/></AuthenticatedRoute>
        
        },
        {
          path : "/account/successpaymentpage",
          element: <AuthenticatedRoute><SuccessPaymentPage/></AuthenticatedRoute>
        },
        {
          path : "/success",
          element: <AuthenticatedRoute><SuccessPaymentPage/></AuthenticatedRoute>
        },
        {
          path : "/success-redeem",
          element: <AuthenticatedRoute><SuccessRedeemPage/></AuthenticatedRoute>
        },
        {
          path: '*',
          element: <NotFoundPage/>
        },
      ]
    }
  ])
}

export default function Router () {
  // If we create the router globally, the loaders of the routes already trigger
  // even before the <AuthContext/> trigger the initial loading of the auth.
  // state.
  const [router, setRouter] = useState(null)
  const config = useConfig()
  useEffect(() => {
    setRouter(createRouter(config))
  }, [config])
  return router ? <RouterProvider router={router} /> : null
}
